/**
 * External dependencies
 */
import { isEqual, keyBy, omit } from 'lodash';
import type { AnyAction } from '@nab/types';

/**
 * Internal dependencies
 */
import { INIT_STATE } from './config';
import type { Action } from './actions';
import type { State } from './types';

export function reducer( state = INIT_STATE, action: AnyAction ): State {
	return actualReducer( state, action as Action ) ?? state;
}

function actualReducer( state: State, action: Action ): State {
	switch ( action.type ) {
		case 'ADD_EXPERIMENT_TYPES': {
			const newExperimentTypes = action.experimentTypes.filter(
				( type ) =>
					! isEqual( state.experimentTypes[ type.name ], type )
			);
			if ( ! newExperimentTypes.length ) {
				return state;
			}

			return {
				...state,
				experimentTypes: {
					...state.experimentTypes,
					...keyBy( newExperimentTypes, 'name' ),
				},
			};
		}

		case 'REMOVE_EXPERIMENT_TYPES': {
			const newExperimentTypes = omit(
				state.experimentTypes,
				action.names
			);
			if ( isEqual( state.experimentTypes, newExperimentTypes ) ) {
				return state;
			}

			return {
				...state,
				experimentTypes: newExperimentTypes,
			};
		}
	}
}
